import { getRootPluaralTranslator } from '@utils/get-module-translator'
import { generateId } from '@utils/id'

const __tc = getRootPluaralTranslator()

export const osComponentFieldMap = () => ({
  os_component: {
    canCreate: true,
    maxCreation: 1,
    title: __tc('os_component'),
    fields: [
      {
        key: generateId(),
        paramName: 'manufacturerId',
        name: __tc('manufacturer'),
        inputType: 'manufacturer',
      },
      {
        key: generateId(),
        paramName: 'osName',
        name: __tc('os_name'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'osVersion',
        name: __tc('os_version'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'architecture',
        name: __tc('os_architecture'),
        inputType: 'dropdown',
        contextOptionKey: 'osArchitectureOptions',
      },
      {
        key: generateId(),
        paramName: 'productKey',
        name: __tc('product_key'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'licenceKey',
        name: __tc('licence_key'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'activationStatus',
        name: __tc('activation_status'),
        inputType: 'dropdown',
        contextOptionKey: 'activationStatusOptions',
      },
      {
        key: generateId(),
        paramName: 'installedDate',
        name: __tc('installed_date'),
        inputType: 'dateTime',
      },
      {
        key: generateId(),
        paramName: 'displayVersion',
        name: __tc('display_version'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'buildNo',
        name: __tc('build_no'),
        inputType: 'text',
      },
    ],
  },
})
